// extracted by mini-css-extract-plugin
export default {"StickyMenu":"styles_StickyMenu__kdMv2","cover":"styles_cover__dyz5m"};